export default __webpack_public_path__ + "static/media/news (1).e7c52583.webp";